export default function initTabs() {
	// console.log("init tabs");
	let tabContainer = document.querySelector(".js-tabs");

	if (tabContainer) {
		// console.log(tabContainer);

		let tabs = tabContainer.querySelectorAll("li");
		let tabContents = document.querySelectorAll(".js-tabs-content div");
		[].forEach.call(tabs, (elem) => {
			elem.addEventListener("click", (e) => {
				e.preventDefault();

				// Set current tab class
				tabContainer.querySelector(".js-active").classList.remove("js-active");
				elem.classList.add("js-active");

				// Show active Tab
				[].forEach.call(tabContents, (e) => e.classList.remove("js-active"));

				let activeTab = document.querySelector(
					".js-tabs-content #" + elem.getAttribute("data-tab")
				);
				activeTab.classList.add("js-active");
			});
		});
	}
}
